import { gql } from "@apollo/client";

export const paymentMutation = gql`
  mutation GetPaymentLink(
    $paymentId: UUID!
    $debtsPaymentInfo: DebtsPaymentInfoInput!
  ) {
    getPaymentLink(
      paymentId: $paymentId
      debtsPaymentInfo: $debtsPaymentInfo
    )
  }
`;
